module.exports = __webpack_public_path__ + "img/social-row.282010ec.jpg";